import React from 'react';
import classNames from 'classnames';

import { getMessage } from 'util/locale';

// components
import { Card, Spinner } from '@tcc/crate';

const baseString = 'vra-awaiting-requirements-check';
const classString = classNames({
  [`${baseString}`]: true
});
const historyPanelClassString = classNames({
  [`${baseString}__history-panel`]: true,
  'vra-review-harvest-history__history-panel': true
});
const AwaitingRequirementsCheck = () => {
  return (
    <section className={classString}>
      <Card className={historyPanelClassString}>
        <Spinner size={24} />
        <span>{getMessage('help-text__harvest-history__requirement-info--pending')}</span>
      </Card>
    </section>
  );
};

AwaitingRequirementsCheck.propTypes = {};

export default AwaitingRequirementsCheck;
